import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '../../components/layout/Spinner';

const RoleBasedRoute = ({
  component: Component,
  allowedRoles = [],
  auth: { isAuthenticated, loading, user },
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      loading ? (
        <Spinner />
      ) : isAuthenticated && user && allowedRoles.includes(user.role) ? (
        <Component {...props} />
      ) : (
        <Redirect to='/' />
      )
    }
  />
);

RoleBasedRoute.propTypes = {
  auth: PropTypes.object.isRequired,
  allowedRoles: PropTypes.array,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(RoleBasedRoute);
